export const VIEW_TYPES = {
  SITEMAP: "SITEMAP",
  CONTACTS: "CONTACTS",
  CONTACTS_EDIT: "CONTACTS_EDIT",
  SERVICE_DEFINITION_EDIT: "SERVICE_DEFINITION_EDIT",
  LAW: "LAW",
  LAW_EDIT: "LAW_EDIT",
  SITEMAP_EDIT: "SITEMAP_EDIT",
  HOME_PAGE_CATEGORY_EDIT: "HOME_PAGE_CATEGORY_EDIT",
  ADMIN_CONSOLE: "ADMIN_CONSOLE",
  EMAIL_NOTIFICATIONS: "EMAIL_NOTIFICATIONS",
  EMAIL_TEMPLATES: "EMAIL_TEMPLATES",
};
